var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPowerBi = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#FFC107"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4267 4.83618H5.57327C4.15797 4.83618 3 5.98772 3 7.40945V15.7854C3 16.982 3.81701 17.9856 4.91708 18.2686V16.8919C4.53753 16.6668 4.28663 16.2551 4.28663 15.7854V7.40945C4.28663 6.7018 4.86562 6.12282 5.57327 6.12282H18.4267C19.1344 6.12282 19.7134 6.7018 19.7134 7.40945V15.7854C19.7134 16.2615 19.456 16.6732 19.0701 16.8984V18.2751C20.183 17.992 21 16.982 21 15.7854V7.40945C21 5.98772 19.8485 4.83618 18.4267 4.83618Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16868 14.4988C7.70135 14.4988 8.13365 14.9311 8.13365 15.4638V18.6804C8.13365 19.2131 7.70135 19.6454 7.16868 19.6454C6.63601 19.6454 6.2037 19.2131 6.2037 18.6804V15.4638C6.2037 14.9311 6.63601 14.4988 7.16868 14.4988Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3853 10.639C10.918 10.639 11.3503 11.0713 11.3503 11.604V18.6804C11.3503 19.2131 10.918 19.6454 10.3853 19.6454C9.85263 19.6454 9.42032 19.2131 9.42032 18.6804V11.604C9.42032 11.0713 9.85263 10.639 10.3853 10.639Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6017 12.5689C14.1344 12.5689 14.5667 13.0012 14.5667 13.5339V18.6804C14.5667 19.2131 14.1344 19.6454 13.6017 19.6454C13.0691 19.6454 12.6367 19.2131 12.6367 18.6804V13.5339C12.6367 13.0012 13.0691 12.5689 13.6017 12.5689Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8184 8.0658C17.3511 8.0658 17.7834 8.4981 17.7834 9.03077V18.6805C17.7834 19.2132 17.3511 19.6455 16.8184 19.6455C16.2858 19.6455 15.8535 19.2132 15.8535 18.6805V9.03077C15.8535 8.4981 16.2858 8.0658 16.8184 8.0658Z",
    fill: "#212121"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPowerBi);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/power-bi.54d83ee6170b579beda8a0ba0be2628c.svg";